import { PlatformProduct } from '../../modules/platform'
import { RootStoreState } from '../root'
import { ProductFilter } from './actions'

export const productFinderResultsSelector = (state: RootStoreState): ReadonlyArray<PlatformProduct> | undefined => state.productfinder.products

export const savedProductFinderFiltersSelector = (state: RootStoreState): ProductFilter | undefined => state.productfinder.savedFilter
